var _defs, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    "data-bbox": "39.5 30 121 140",
    "data-type": "color",
    viewBox: "39.5 30 121 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "#comp-m69434ay3__item-ker6vlu0 svg [data-color=&quot;1&quot;]{fill:#1d0e03}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4acdde",
    d: "M100 30 39.5 65.1v40.6L100 70.8l60.5 34.9v29.2-69.8L100 30z",
    "data-color": 1,
    opacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4acdde",
    d: "m100 70.8-60.5 34.9v11.9l60.5-35 60.5 35v17.3-29.2L100 70.8z",
    "data-color": 1,
    opacity: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4acdde",
    d: "m100 82.6-60.5 35v11.9l60.5-35 60.5 35v5.4-17.3l-60.5-35z",
    "data-color": 1,
    opacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4acdde",
    d: "m100 94.5-60.5 35v5.4l5.6 3.2 54.9-31.7 54.9 31.7 5.6-3.2v-5.4l-60.5-35z",
    "data-color": 1,
    opacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#4acdde",
    d: "m45.1 138.1 12.1 7.1 42.8-24.8 42.8 24.8 12.1-7.1-54.9-31.7-54.9 31.7z",
    "data-color": 1,
    opacity: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4acdde",
    d: "M57.2 145.2 100 170l42.8-24.8-42.8-24.8-42.8 24.8z",
    "data-color": 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.a631a9a769fdb3cdad72d477a7586c9c.svg";
export { ForwardRef as ReactComponent };